import React from 'react';

import { ChannelLinkDataModelNameEnum } from 'redpoints-front-common/enumerations';

import IncidentDetailsAccount from './IncidentDetailsAccount';
import IncidentDetailsLinkDataCommon from './IncidentDetailsLinkDataCommon';
import IncidentDetailsLinkDataImageList from './IncidentDetailsLinkDataImageList';
import IncidentDetailsLinkDataMultimediaFile from './IncidentDetailsLinkDataMultimediaFile';
import IncidentDetailsLinkDataOfferListing from './IncidentDetailsLinkDataOfferListing';
import IncidentDetailsLinkDataOverallMultimedia from './IncidentDetailsLinkDataOverallMultimedia';
import IncidentDetailsLinkDataPriceList from './IncidentDetailsLinkDataPriceList';
import IncidentDetailsLinkDataProductListing from './IncidentDetailsLinkDataProductListing';
import IncidentDetailsLinkDataSocialMedia from './IncidentDetailsLinkDataSocialMedia';
import IncidentDetailsSeller from './IncidentDetailsSeller';

const IncidentDetailsLinkDataContentExtractedData = ({
  accountData,
  accountLinkDataChange,
  accountLinkDataValidate,
  commonLinkDataChange,
  commonLinkDataValidate,
  forceValidation,
  hasAccountPermission,
  hasLinkDataPermissions,
  hasSellerPermission,
  linkData,
  linkImageListLinkDataChange,
  linkImageListLinkDataValidate,
  linkMetadata,
  linkPriceListChange,
  linkPriceListValidate,
  multimediaFileLinkDataChange,
  multimediaFileLinkDataValidate,
  offerListingChange,
  offerListingValidate,
  overallMultimediaChange,
  overallMultimediaValidate,
  productListingChange,
  productListingValidate,
  sellerData,
  sellerLinkDataChange,
  sellerLinkDataValidate,
  socialMediaLinkDataChange,
  socialMediaLinkDataValidate,
  isSearchLoading,
  onSearch,
  searchStatus,
}) => {
  const commonLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.COMMONLINKDATA.name
  );
  const overallMultimediaLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.OVERALLMULTIMEDIALINKDATA.name
  );
  const productListingLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.PRODUCTLISTINGLINKDATA.name
  );
  const socialMediaLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.SOCIALMEDIALINKDATA.name
  );
  const linkImageListLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.LINKIMAGE.name
  );
  const linkPriceMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.LINKPRICE.name
  );
  const multimediaFileLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.MULTIMEDIAFILELINKDATA.name
  );
  const offerListingLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.OFFERLISTINGLINKDATA.name
  );
  const accountLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.ACCOUNT.name
  );
  const sellerLinkMetadata = linkMetadata?.get(
    ChannelLinkDataModelNameEnum.SELLER.name
  );

  if (linkMetadata.size) {
    return (
      <div className="incident-details-extracted-data-container">
        {accountLinkMetadata && (
          <IncidentDetailsAccount
            accountData={accountData}
            accountLinkDataChange={accountLinkDataChange}
            accountLinkDataValidate={accountLinkDataValidate}
            accountLinkMetadata={accountLinkMetadata}
            editable={hasAccountPermission}
            forceValidation={forceValidation}
            isSearchLoading={isSearchLoading}
            onSearch={onSearch}
            searchStatus={searchStatus}
          />
        )}
        {sellerLinkMetadata && (
          <IncidentDetailsSeller
            editable={hasSellerPermission}
            forceValidation={forceValidation}
            sellerData={sellerData}
            sellerLinkDataChange={sellerLinkDataChange}
            sellerLinkDataValidate={sellerLinkDataValidate}
            sellerLinkMetadata={sellerLinkMetadata}
          />
        )}
        {commonLinkMetadata && (
          <IncidentDetailsLinkDataCommon
            commonLinkData={linkData?.commonLinkData}
            commonLinkDataChange={commonLinkDataChange}
            commonLinkDataValidate={commonLinkDataValidate}
            commonLinkMetadata={commonLinkMetadata}
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
          />
        )}
        {socialMediaLinkMetadata && (
          <IncidentDetailsLinkDataSocialMedia
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
            socialMediaLinkData={linkData?.socialMediaLinkData}
            socialMediaLinkDataChange={socialMediaLinkDataChange}
            socialMediaLinkDataValidate={socialMediaLinkDataValidate}
            socialMediaLinkMetadata={socialMediaLinkMetadata}
          />
        )}
        {linkPriceMetadata && (
          <IncidentDetailsLinkDataPriceList
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
            linkDataPriceList={linkData?.linkPriceList}
            linkPriceListChange={linkPriceListChange}
            linkPriceListValidate={linkPriceListValidate}
            linkPriceMetadata={linkPriceMetadata}
          />
        )}
        {productListingLinkMetadata && (
          <IncidentDetailsLinkDataProductListing
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
            productListingChange={productListingChange}
            productListingLinkData={linkData?.productListingLinkData}
            productListingLinkMetadata={productListingLinkMetadata}
            productListingValidate={productListingValidate}
          />
        )}
        {offerListingLinkMetadata && (
          <IncidentDetailsLinkDataOfferListing
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
            offerListingChange={offerListingChange}
            offerListingLinkData={linkData?.offerListingLinkData}
            offerListingLinkMetadata={offerListingLinkMetadata}
            offerListingValidate={offerListingValidate}
          />
        )}
        {overallMultimediaLinkMetadata && (
          <IncidentDetailsLinkDataOverallMultimedia
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
            overallMultimediaChange={overallMultimediaChange}
            overallMultimediaLinkData={linkData?.overallMultimediaLinkData}
            overallMultimediaLinkMetadata={overallMultimediaLinkMetadata}
            overallMultimediaValidate={overallMultimediaValidate}
          />
        )}
        {multimediaFileLinkMetadata && (
          <IncidentDetailsLinkDataMultimediaFile
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
            multimediaFileLinkData={linkData?.multimediaFileLinkData}
            multimediaFileLinkDataChange={multimediaFileLinkDataChange}
            multimediaFileLinkDataValidate={multimediaFileLinkDataValidate}
            multimediaFileLinkMetadata={multimediaFileLinkMetadata}
          />
        )}
        {linkImageListLinkMetadata && (
          <IncidentDetailsLinkDataImageList
            editable={hasLinkDataPermissions}
            forceValidation={forceValidation}
            linkImageListLinkData={linkData?.linkImageList}
            linkImageListLinkDataChange={linkImageListLinkDataChange}
            linkImageListLinkDataValidate={linkImageListLinkDataValidate}
            linkImageListLinkMetadata={linkImageListLinkMetadata}
          />
        )}
      </div>
    );
  }

  return null;
};

export default IncidentDetailsLinkDataContentExtractedData;
